@if (compact) {
<!-- One row of the "Elenco" view: the same data and buttons as the card, side by side -->
<article class="tech-row">
  <div class="tech-row__who">
    <span class="xr-avatar tech-row__avatar" aria-hidden="true">
      @if (technician?.avatar) {
        <img [src]="technician?.avatar" alt=""/>
      } @else {
        {{ initials }}
      }
    </span>
    <span class="tech-row__identity">
      <strong>{{ technician?.name | titlecase }} {{ technician?.lastname | titlecase }}</strong>
      <small>{{ technician?.email }}</small>
    </span>
  </div>
  <span class="tech-row__cell"><span class="xr-badge xr-badge--plain tech-card__type">{{ roleLabelKey | translate }}</span></span>
  <span class="tech-row__cell" [attr.data-label]="'technicians_page.company' | translate">{{ technician?.company?.name || '—' }}</span>
  <span class="tech-row__cell" [attr.data-label]="'technicians_page.room' | translate">
    @if (isFieldTechnician) {
      {{ roomLabel || ('technicians_page.no_room' | translate) }}
      @switch (status) {
        @case ('in_call') { <span class="xr-badge xr-badge--busy">{{ 'technicians_page.status_in_call' | translate }}</span> }
        @case ('waiting') { <span class="xr-badge xr-badge--wait">{{ 'technicians_page.status_waiting' | translate }}</span> }
      }
    } @else {
      —
    }
  </span>
  <div class="tech-row__actions">
    @if (isFieldTechnician) {
      <button type="button" class="xr-btn xr-btn--small" [ngClass]="status === 'waiting' ? 'xr-btn--primary' : 'xr-btn--secondary'"
              [disabled]="!canConnect" [matTooltip]="tooltipKey | translate" [matTooltipDisabled]="canConnect || !tooltipKey"
              (click)="connectToRoom()">{{ 'technicians_page.join' | translate }}</button>
      <button type="button" class="xr-btn xr-btn--soft xr-btn--small" [disabled]="!qrcode" (click)="viewFile()"
              [matTooltip]="'technicians_page.qr_view' | translate">
        <i-tabler name="qrcode" class="icon-16 d-flex" aria-hidden="true"></i-tabler>
        <span class="xr-sr-only">{{ 'technicians_page.qr_label' | translate }}</span>
      </button>
    }
    <button type="button" class="xr-btn xr-btn--secondary xr-btn--small" (click)="openTechnician(technician)">
      {{ 'technicians_page.edit' | translate }}
    </button>
  </div>
</article>
} @else {
<article class="xr-card tech-card">
  <div class="tech-card__head">
    <span class="xr-avatar tech-card__avatar" aria-hidden="true">
      @if (technician?.avatar) {
        <img [src]="technician?.avatar" alt=""/>
      } @else {
        {{ initials }}
      }
    </span>
    <div class="tech-card__identity">
      <h2 class="tech-card__name">{{ technician?.name | titlecase }} {{ technician?.lastname | titlecase }}</h2>
      <div class="tech-card__badges">
      <span class="xr-badge xr-badge--plain tech-card__type">{{ roleLabelKey | translate }}</span>
      @if (isFieldTechnician) {
      @switch (status) {
        @case ('in_call') {
          <span class="xr-badge xr-badge--busy">{{ 'technicians_page.status_in_call' | translate }}</span>
        }
        @case ('waiting') {
          <span class="xr-badge xr-badge--wait">{{ 'technicians_page.status_waiting' | translate }}</span>
        }
        @default {
          <span class="xr-badge xr-badge--off">{{ 'technicians_page.status_offline' | translate }}</span>
        }
      }
      }
      </div>
    </div>
  </div>

  <dl class="tech-card__details">
    <dt>{{ 'technicians_page.email' | translate }}</dt>
    <dd>{{ technician?.email }}</dd>
    <dt>{{ 'technicians_page.phone' | translate }}</dt>
    <dd>
      @if (technician?.phone) {
        {{ technician?.prefix?.prefix }} {{ technician?.phone }}
      } @else {
        {{ 'technicians_page.no_phone' | translate }}
      }
    </dd>
    @if (technician?.company?.name) {
      <dt>{{ 'technicians_page.company' | translate }}</dt>
      <dd>{{ technician?.company?.name }}</dd>
    }
    @if (isFieldTechnician) {
      <dt>{{ 'technicians_page.room' | translate }}</dt>
      <dd>{{ roomLabel || ('technicians_page.no_room' | translate) }}</dd>
    }
  </dl>

  @if (isFieldTechnician) {
  <div class="tech-card__qr">
    <span class="tech-card__qr-label">{{ 'technicians_page.qr_label' | translate }}</span>
    <button type="button" class="xr-btn xr-btn--soft xr-btn--small" [disabled]="!qrcode" (click)="viewFile()">
      <i-tabler name="qrcode" class="icon-16 d-flex" aria-hidden="true"></i-tabler>
      {{ 'technicians_page.qr_view' | translate }}
    </button>
    <button type="button" class="xr-btn xr-btn--soft xr-btn--small" [disabled]="!qrcode" (click)="downloadQrcode()">
      <i-tabler name="download" class="icon-16 d-flex" aria-hidden="true"></i-tabler>
      {{ 'technicians_page.qr_download' | translate }}
    </button>
    <button type="button" class="xr-btn xr-btn--soft xr-btn--small" [disabled]="!qrcode" (click)="sendEmail(technician)">
      <i-tabler name="send-2" class="icon-16 d-flex" aria-hidden="true"></i-tabler>
      {{ 'technicians_page.qr_email' | translate }}
    </button>
  </div>
  }

  <div class="tech-card__actions">
    @if (isFieldTechnician) {
    <span
      class="tech-card__join"
      [matTooltip]="tooltipKey | translate"
      [matTooltipDisabled]="canConnect || !tooltipKey"
      matTooltipClass="tooltip-centered"
    >
      <button type="button" class="xr-btn xr-btn--primary" [disabled]="!canConnect" (click)="connectToRoom()">
        @if (canConnect) {
          {{ 'technicians_page.join' | translate }}
        } @else if (status === 'in_call') {
          {{ 'technicians_page.join_busy' | translate }}
        } @else {
          {{ 'technicians_page.join_no_room' | translate }}
        }
      </button>
    </span>
    }
    <button type="button" class="xr-btn xr-btn--secondary" (click)="openTechnician(technician)">
      {{ 'technicians_page.edit' | translate }}
    </button>
  </div>

</article>
}
